<template>
  <div class="content-text">
    <h2 class="title-3 text-left">9.2 Saúde bucal</h2>

    <p>
      No FNS, a ação detalhada “INCENTIVO FINANCEIRO PARA ATENÇÃO À SAÚDE BUCAL”
      está composta por todos os recursos destinados ao componente de Atenção à
      Saúde Bucal, inclusive o componente de qualidade. Este valor é composto
      por recursos:
    </p>

    <ol start="1" class="roman-list">
      <li>I - das equipes de Saúde Bucal (eSB);</li>
      <li>II - das Unidades Odontológicas Móveis (UOM);</li>
      <li>III - dos Centros de Especialidades Odontológicas (CEO);</li>
      <li>IV - dos Laboratórios Regionais de Prótese Dentária (LRPD);</li>
      <li>V - dos Serviços de Especialidades em Saúde Bucal (SESB);</li>
      <li>
        VI – Componente fixo de implantação das equipes eSB 40h quando houver; e
      </li>
      <li><b>VII – Componente qualidade das equipes eSB.</b></li>
    </ol>

    <p>
      Para identificar o valor atribuído ao componente qualidade, ou seja, aos
      indicadores de saúde bucal, com base no recurso disponível no FNS, basta
      acessar o e-GESTOR e subtrair os valores correspondentes aos itens de I a
      VI. O resultado obtido será o valor destinado ao componente de qualidade
      das equipes de Saúde Bucal do município, conforme está no quadro 11.
    </p>

    <div class="container-table">
      <span style="text-transform: uppercase; font-weight: bold"
        >Quadro 11 - DETALHAMENTO DO RECURSO MENSAL DE INCENTIVO FINANCEIRO PARA
        ATENÇÃO À SAÚDE BUCAL DO FNS
      </span>
      <table>
        <thead>
          <tr>
            <th>DESCRIÇÃO</th>
            <th>VALOR POR COMPONENTE</th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr>
            <td>Fixo de implantação</td>
            <td>-</td>
            <td class="text-right">
              R$
              {{
                valorFixoImplantacao.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr> -->
          <tr>
            <td>Custeio ESB</td>
            <td class="text-center">
              R$ {{ getValorCusteio('equipes_saude_bucal').valorFormatado }}
            </td>
          </tr>
          <tr>
            <td>Custeio UOM</td>
            <td class="text-center">
              R$ {{ getValorCusteio('uom').valorFormatado }}
            </td>
          </tr>
          <tr>
            <td>Custeio CEO</td>
            <td class="text-center">
              R$ {{ getValorCusteio('ceo').valorFormatado }}
            </td>
          </tr>
          <tr>
            <td>Custeio LRPD</td>
            <td class="text-center">
              R$ {{ getValorCusteio('lrpd').valorFormatado }}
            </td>
          </tr>
          <tr>
            <td>Custeio SESB</td>
            <td class="text-center">
              R$ {{ getValorCusteio('sesb').valorFormatado }}
            </td>
          </tr>
          <tr>
            <td>Qualidade indicadores ESB 40h</td>
            <td class="text-center">
              R$
              {{
                valorQualidade.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr>
          <tr class="grey">
            <td><strong>Total</strong></td>
            <td class="text-center">
              <strong
                >R$
                {{
                  totalGeral.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })
                }}</strong
              >
            </td>
          </tr>
        </tbody>
      </table>
      <span class="fonte" v-html="fonte"></span>
    </div>
  </div>
</template>

<script>
import { regras, getLabelRegra } from '../utils.js'

export default {
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
    fixo: {
      type: Object,
      default: () => {},
    },
    fonte: {
      type: String,
      default: '',
    },
    classificacao: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      somaGeralCusteio: 0,
    }
  },
  mounted() {},
  computed: {
    valorQualidade() {
      const equipes = this.dados?.etapa4?.equipes || []

      return equipes
        .filter((item) => {
          return (
            item.componente === 'eSB' &&
            [
              'eSB I - Comum',
              'eSB II - Comum',
              'eSB I - Quil/Assent',
              'eSB II - Quil/Assent',
            ].includes(item.equipe)
          )
        })
        .reduce((total, item) => {
          return total + Number(item.valorTotal || 0)
        }, 0)
    },

    totalGeral() {
      return (
        this.getValorCusteio('equipes_saude_bucal').valor +
        this.getValorCusteio('uom').valor +
        this.getValorCusteio('ceo').valor +
        this.getValorCusteio('lrpd').valor +
        this.getValorCusteio('sesb').valor +
        this.valorQualidade
      )
    },
  },
  methods: {
    getValorCusteio(key) {
      const item = this.dados.etapa8.equipes.find((el) => {
        return el.key == key
      })
      if (item != undefined) {
        return {
          valor: Number(item.value),
          valorFormatado: item.value.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          }),
        }
      } else {
        return 0
      }
    },
  },
}
</script>

<style lang="scss"></style>
